import { render, staticRenderFns } from "./editCommunityRecommend.vue?vue&type=template&id=f05079fc&scoped=true"
import script from "./editCommunityRecommend.vue?vue&type=script&lang=js"
export * from "./editCommunityRecommend.vue?vue&type=script&lang=js"
import style0 from "./editCommunityRecommend.vue?vue&type=style&index=0&id=f05079fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05079fc",
  null
  
)

export default component.exports